// extracted by mini-css-extract-plugin
export default {"root":"SectionHeader-module__root","title":"SectionHeader-module__title","range":"SectionHeader-module__range"};